import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';

export type SapUnavailableAlertItem = {
    clientId: string;
    label: string;
};

type Props = {
    alerts: SapUnavailableAlertItem[];
};

export function SapUnavailableAlerts({ alerts }: Props) {
    if (alerts.length === 0) {
        return null;
    }
    return (
        <Stack spacing={1} sx={{ mb: 2 }}>
            {alerts.map((alert) => (
                <Alert key={alert.clientId} severity="warning">
                    {alert.label}
                </Alert>
            ))}
        </Stack>
    );
}
